import styled from "styled-components"
import Breakpoints from "../shared/breakpoints"
import Typography from "../shared/typography.styles"
import Link from "../shared/smart-link"
import Img from "gatsby-image"

export const SectionContainer = styled.div`
  padding: 64px 0 56px 0;
  @media (min-width: ${Breakpoints.md}) {
    padding: 64px 0 24px 0;
  }

  padding: 96px 0 48px 0;
`

export const Title = styled.h2`
  ${Typography.mobileTextStyles.MobileHeadingTwoSemiBold}
  grid-column: 2 / -2;
  color: var(--slate);
  @media (min-width: ${Breakpoints.md}) {
    ${Typography.tabletTextStyles.TabletHeadingTwoSemiBold}
    text-align: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.HeadingTwoSemiBold}
  }
`

export const TextContent = styled.div`
  ${Typography.mobileTextStyles.MobileBodyRegular}
  grid-column: 2 / -2;
  color: var(--body-text-grey);
  margin-top: 32px;

  @media (min-width: ${Breakpoints.md}) {
    ${Typography.tabletTextStyles.TabletBodyRegular}

    grid-column: 2 / -2;
    text-align: center;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.BodyText18}
    grid-column: 3 / -3;
  }
`

export const Headline = styled.p`
  display: block;
  margin-bottom: 2rem;
  @media (min-width: ${Breakpoints.md}) {
    font-weight: 400;

    display: inline;
  }
  @media (min-width: ${Breakpoints.lg}) {
    display: block;
  }
`

export const P = styled.p`
  display: block;
  :not(:last-child) {
    margin-bottom: 2rem;
  }
  @media (min-width: ${Breakpoints.md}) {
    display: inline;
    :not(:last-child) {
      margin-bottom: 0;
    }
  }
`

export const SocialRow = styled.div`
  display: flex;
  flex-direction: row;
  grid-column: 1 / -1;
  margin-top: 32px;
  align-items: center;
  justify-content: center;
  justify-self: center;

  & > img {
    display: none;
    @media (min-width: ${Breakpoints.md}) {
      display: unset;
    }
  }
`

export const SocialLink = styled(Link)`
  ${Typography.desktopTextStyles.HeadingSixRegular}

  &,
  :visited,
  :link,
  :active {
    color: var(--white);
  }

  background-color: var(--burnt-orange);

  padding: 16px 32px;
  text-decoration: none;

  flex: 0 1 282px;
  text-align: center;

  @media (min-width: ${Breakpoints.md}) {
    font-weight: 400;

    margin-left: 16px;
    padding: 0;

    background-color: unset;

    &,
    :visited,
    :link,
    :active {
      color: var(--burnt-orange);
    }
  }
`

export const SliderContainer = styled.div`
  grid-column: 1 / -1;
  padding: 0 5vw;
  margin-top: 32px;
  padding-bottom: 16px;
  overflow: hidden;
`

export const MosaicImage = styled(Img)`
  display: none;

  @media (min-width: ${Breakpoints.md}) {
    display: initial;
    grid-column: 1 / -1;

    margin-top: 56px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 72px;
  }
`
